export interface AboutValueItemProps {
  label: string
}

export const useAboutValueItem = (props: AboutValueItemProps) => {
  return {
    ...props,
  }
}
